var Orders = $.extend(false, BaseModule ,{
    api_route : 'orders',

    original_data : {},
	data : {
        module:'orders',
        id:0,
        offset:48,
        page:0,
        sort_term:'created_at',
        sort_way:'DESC',
        view:'list',
        pagination      : true
    },
    
    capture:function(id){


        var r = confirm("Are you sure you want to capture the selected payment?");
        if (r == true) {

            var module = this, 
                module_name = module.data.module;     

            $.ajax({
                url : API + module.api_route+'/capture',
                method:'PUT',
                data:{id:id},
                success:function(data){
                    if(data.success){
                       alert(data.success);
                        module.load_list();
                    }else{
                       alert(data.error);
                    } 
                }
            }); 
        }             
    },

    fulfillOrder:function(){
        var module = this, module_name = module.data.module;
        $('.fulfill-order').change(function(){            
            var $this = $(this);
            var $val = $this.val();            
            if($val){
                var r = confirm("Are you sure you want to fulfill this order?");
                if (r == true) {
                    

                    $.ajax({
                        url : API + module.api_route+'/fulfill',
                        method:'put',
                        data:{
                            data:$val
                        },
                        success:function(data){
                           if(data.success){                                
                                module.load_list();
                            }else{
                                alert(data);
                            }
                        }
                    });
                }
            }  
        });
             
    },

	init:function(){
		"use strict";
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
	Orders.init();

});
